import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import API from '../../../api';
import { getApiMyBoardsSuccess } from '../../Board/Board.actions';
import CommunicatorDialog from './CommunicatorDialog.component';
import dialogMessages from './CommunicatorDialog.messages';

const BOARDS_PAGE_LIMIT = 10000;

class CommunicatorDialogContainer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      boards: [],
      total: 0
    };
  }

  async componentDidMount() {
    await this.fetchBoards();
  }

  async fetchBoards() {
    this.setState({ loading: true });
    try {
      const response = await API.getBoards({ limit: 10000 });
      const allBoards = response.data || [];
      // Exclude root board and folder boards (boards with a parent)
      const boards = allBoards.filter(b => b.id !== 'root' && !b.parent);
      this.setState({ boards, total: boards.length, loading: false });
    } catch (err) {
      console.error('Failed to fetch boards:', err);
      this.setState({ loading: false });
    }
  }

  async deleteBoard(board) {
    const boardId = board._id || board.id;

    // Check if board has tiles
    if (board.tiles && board.tiles.length > 0) {
      throw new Error(this.props.intl.formatMessage(dialogMessages.boardNotEmpty));
    }

    try {
      await API.deleteBoardRecursive(boardId);
      // Remove from local state
      this.setState(prev => {
        const boards = prev.boards.filter(b => (b._id || b.id) !== boardId);
        return { boards, total: boards.length };
      });
      // Refresh Redux store so dropdown updates
      const resBoards = await API.getPublicBoards({ limit: BOARDS_PAGE_LIMIT });
      this.props.dispatch(getApiMyBoardsSuccess(resBoards));
      // Navigate to root and refresh board view
      if (this.props.onBoardDeleted) {
        await this.props.onBoardDeleted();
      }
    } catch (err) {
      throw err;
    }
  }

  render() {
    const { open, onClose, intl } = this.props;
    const { loading, boards, total } = this.state;

    return (
      <CommunicatorDialog
        open={open}
        onClose={onClose}
        intl={intl}
        loading={loading}
        boards={boards}
        total={total}
        deleteBoard={this.deleteBoard.bind(this)}
        dark={this.props.dark}
      />
    );
  }
}

const mapStateToProps = ({ app }) => ({
  dark: app.displaySettings.darkThemeActive
});

export default connect(mapStateToProps)(injectIntl(CommunicatorDialogContainer));
